var collapsible_list_pair_rtlignore_default = {
  "container": "gn0lx",
  "title": "fDM9q",
  "viewerContainer": "QpQoR",
  "titleContainer": "W6aej",
  "content": "_20EqV",
  "expandIcon": "Ty-rf",
  "dndIcon": "XGPjx",
  "RTL": "YvZGl",
  "LTR": "jVMco",
  "itemContainer": "YpeTZ",
  "itemContainerViewer": "xugXj",
  "mouseDown": "gpuVE",
  "innerEditor": "DNa3m",
  "item": "_4vpCQ",
  "floatingAddPluginMenuWrapper": "kpmoS"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
